import { PlatformTableData, PlatformTableListRows200 } from 'shared/base';

export const processPaginatedListData = (
  requestUrl: string,
  data: PlatformTableData,
): PlatformTableListRows200 => {
  const params = new URLSearchParams(requestUrl);
  const pageSize = params.get('per_page');
  const page = params.get('page') ?? 1;

  const chunkStart = (Number(page) - 1) * Number(pageSize);
  const chunkEnd = chunkStart + Number(pageSize);

  return {
    data: {
      columns: data.columns,
      rows: data.rows.slice(chunkStart, chunkEnd),
    },
    metadata: {
      last_page: Math.ceil(data.rows.length / Number(pageSize)),
      page_size: Number(pageSize),
      total_count: data.rows.length,
    },
  };
};
